module.exports = __webpack_public_path__ + "static/media/notifications.f22f01f4.svg";